// Era-grouped enemy archetypes used for round-based spawning
// Each entry tunes base stats and visuals; wave scaling still applies.

const ENEMY_LIBRARY = {
  '초기': [
    {
      id: 'raider_longboat',
      name: '장선(약탈선)',
      hpMul: 1.0,
      speedMul: 1.0,
      defense: 0,
      size: 12,
      rewardMul: 1.0,
      color: '#a97236',
    },
    {
      id: 'fireship',
      name: '화공선',
      hpMul: 0.9,
      speedMul: 1.2,
      defense: 0,
      size: 10,
      rewardMul: 1.1,
      color: '#c97a3b',
    },
    {
      id: 'oared_assault',
      name: '노선 강습대',
      hpMul: 1.1,
      speedMul: 0.95,
      defense: 1,
      size: 13,
      rewardMul: 1.0,
      color: '#8a5a2b',
    },
  ],
  '조선': [
    {
      id: 'kobaya',
      name: '왜선 코바야',
      hpMul: 1.0,
      speedMul: 1.15,
      defense: 0,
      size: 11,
      rewardMul: 1.0,
      color: '#7a9155',
    },
    {
      id: 'sekibune',
      name: '세키부네',
      hpMul: 1.2,
      speedMul: 0.95,
      defense: 1,
      size: 13,
      rewardMul: 1.1,
      color: '#5d7d3d',
    },
    {
      id: 'fireship_joseon',
      name: '화공선(왜)',
      hpMul: 0.9,
      speedMul: 1.2,
      defense: 0,
      size: 10,
      rewardMul: 1.1,
      color: '#8f7a3e',
    },
  ],
  '근대': [
    {
      id: 'gunboat',
      name: '포함',
      hpMul: 1.25,
      speedMul: 1.0,
      defense: 2,
      size: 14,
      rewardMul: 1.2,
      color: '#567699',
    },
    {
      id: 'torpedo_boat_enemy',
      name: '어뢰정(적)',
      hpMul: 0.95,
      speedMul: 1.25,
      defense: 1,
      size: 11,
      rewardMul: 1.1,
      color: '#4b8aa6',
    },
    {
      id: 'armored_cruiser_enemy',
      name: '장갑함(적)',
      hpMul: 1.5,
      speedMul: 0.9,
      defense: 3,
      size: 16,
      rewardMul: 1.4,
      color: '#3d5a7a',
    },
  ],
  '현대': [
    {
      id: 'nk_missile_boat',
      name: '미사일 고속정(적)',
      hpMul: 1.1,
      speedMul: 1.3,
      defense: 2,
      size: 12,
      rewardMul: 1.2,
      color: '#c85f85',
    },
    {
      id: 'nk_gun_boat',
      name: '포고속정(적)',
      hpMul: 1.25,
      speedMul: 1.1,
      defense: 2,
      size: 13,
      rewardMul: 1.2,
      color: '#b4576f',
    },
    {
      id: 'midget_sub',
      name: '소형 잠수정',
      hpMul: 1.4,
      speedMul: 0.95,
      defense: 4,
      size: 14,
      rewardMul: 1.5,
      color: '#5f6b78',
    },
  ],
};

export { ENEMY_LIBRARY };
